// extracted by mini-css-extract-plugin
export default {"button":"ConstructorLogicButton_button__AgLrM","active":"ConstructorLogicButton_active__pnWX+","inactive":"ConstructorLogicButton_inactive__1kgvp"};